import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import aifEndorsement from "../assets/images/AIF.JPG";
import afpActionEndorsement from "../assets/images/AFP.jpg";
import brianHodgersScheinerEndorsement from "../assets/images/brian-hodgers-scheiner-endorsement-graphic.jpg";
import fopEndorsement from "../assets/images/brian-hodgers-fop-endorsement-graphic-a.jpg";
import chamberEndorsement from "../assets/images/chamber_of_commerce.JPG";
import conservativeWatchEndorsement from "../assets/images/conservative_watch.JPG";
import businessVoiceEndorsement from "../assets/images/Business Voice.jpg";
import daveWeldonEndorsement from "../assets/images/dave-weldon-endorsement-graphic.jpg";
import firefightersEndorsement from "../assets/images/FireFighters.jpg";
import floridaRealtorsEndorsement from "../assets/images/florida_realtors.jpg";
import floridaAbcEndorsement from "../assets/images/florida-abc-endorsement-graphic.jpg";
import floridaFamilyActionEndorsement from "../assets/images/Fl Fam Action.jpg";
import mikeHaridopolosEndorsement from "../assets/images/mike-haridopolos-endorsement-graphic-a (002).jpg";
import nraEndorsement from "../assets/images/NRA.jpg";
import pbaEndorsement from "../assets/images/PBA.jpg";
import rockledgeEndorsement from "../assets/images/Rockledge.jpg";
import sadoffEndorsement from "../assets/images/Sadoff.jpg";
import scottEllisEndorsement from "../assets/images/scott-ellis-endorsement-graphic.jpg";
import spaceCoastYoungRepublicansEndorsement from "../assets/images/SpCoastYR.jpeg";
import spaceCoastRealtorsEndorsement from "../assets/images/space_coast_association_of_realtors.jpg";
import wayneIveyEndorsement from "../assets/images/wayne-ivey-endorsement-graphic.jpg";

const endorsementCards = [
  {
    name: "Wayne Ivey, Brevard County Sheriff",
    image: wayneIveyEndorsement,
    featured: true,
    description: "Endorsed by Brevard County Sheriff Wayne Ivey."
  },
  {
    name: "Mike Haridopolos, Congressman",
    image: mikeHaridopolosEndorsement,
    featured: true,
    description: "Endorsed by Congressman Mike Haridopolos."
  },
  {
    name: "National Rifle Association",
    image: nraEndorsement,
    featured: true,
    description: "Endorsed by the National Rifle Association."
  },
  {
    name: "Americans for Prosperity Action",
    image: afpActionEndorsement,
    featured: true,
    description: "Endorsed by Americans for Prosperity Action."
  },
  {
    name: "Florida Family Action",
    image: floridaFamilyActionEndorsement,
    featured: true,
    description: "Endorsed by Florida Family Action."
  },
  {
    name: "ABC Florida East Coast",
    image: floridaAbcEndorsement,
    featured: true,
    description: "Endorsed by Associated Builders and Contractors Florida East Coast."
  },
  {
    name: "Florida State Fraternal Order of Police",
    image: fopEndorsement,
    featured: true,
    description: "Endorsed by the Florida State Fraternal Order of Police."
  },
  {
    name: "Florida Police Benevolent Association",
    image: pbaEndorsement,
    featured: true,
    description: "Officially endorsed by the Florida Police Benevolent Association."
  },
  {
    name: "Florida Professional Firefighters",
    image: firefightersEndorsement,
    featured: true,
    description: "Endorsed by Florida Professional Firefighters."
  },
  {
    name: "Scott Ellis, Former Brevard County Clerk of Courts",
    image: scottEllisEndorsement,
    featured: true,
    description: "Endorsed by former Brevard County Clerk of Courts Scott Ellis."
  },
  {
    name: "Rachel Sadoff, Brevard Clerk of Courts & Comptroller",
    image: sadoffEndorsement,
    featured: true,
    description: "Endorsed by Brevard Clerk of Courts & Comptroller Rachel Sadoff."
  },
  {
    name: "Tom Price, Mayor of Rockledge",
    image: rockledgeEndorsement,
    featured: true,
    description: "Endorsed by Rockledge Mayor Tom Price."
  },
  {
    name: "William Scheiner, State Attorney",
    image: brianHodgersScheinerEndorsement,
    featured: true,
    description: "Endorsed by William Scheiner, State Attorney for the 18th Judicial Circuit."
  },
  {
    name: "Dr. Dave Weldon, Former U.S. Congressman",
    image: daveWeldonEndorsement,
    featured: true,
    description: "Endorsed by former U.S. Congressman Dr. Dave Weldon."
  },
  {
    name: "Florida Realtors",
    image: floridaRealtorsEndorsement,
    description: "Industry support for affordability and property-rights priorities."
  },
  {
    name: "Space Coast Association of Realtors",
    image: spaceCoastRealtorsEndorsement,
    description: "Local support from real estate leaders in the region."
  },
  {
    name: "Space Coast Young Republicans",
    image: spaceCoastYoungRepublicansEndorsement,
    featured: true,
    description: "Endorsed by Space Coast Young Republicans."
  },
  {
    name: "Associated Industries of Florida",
    image: aifEndorsement,
    description: "Statewide business support for practical conservative leadership."
  },
  {
    name: "Business Voice of Florida's Space Coast",
    image: businessVoiceEndorsement,
    description: "Local business backing from the Space Coast."
  },
  {
    name: "Conservative Watch USA",
    image: conservativeWatchEndorsement,
    description: "Support for dependable conservative results."
  },
  {
    name: "Florida Chamber of Commerce",
    image: chamberEndorsement,
    description: "Pro-growth leadership recognized by Florida business advocates."
  }
];

const carouselSlides = [
  {
    image: wayneIveyEndorsement,
    title: "Endorsed by Brevard County Sheriff Wayne Ivey.",
    eyebrow: "New endorsement"
  },
  {
    image: mikeHaridopolosEndorsement,
    title: "Endorsed by Congressman Mike Haridopolos.",
    eyebrow: "New endorsement"
  },
  {
    image: nraEndorsement,
    title: "Endorsed by the National Rifle Association.",
    eyebrow: "New endorsement"
  },
  {
    image: afpActionEndorsement,
    title: "Endorsed by Americans for Prosperity Action.",
    eyebrow: "New endorsement"
  },
  {
    image: floridaFamilyActionEndorsement,
    title: "Endorsed by Florida Family Action.",
    eyebrow: "New endorsement"
  },
  {
    image: floridaAbcEndorsement,
    title: "Endorsed by ABC Florida East Coast.",
    eyebrow: "New endorsement"
  },
  {
    image: fopEndorsement,
    title: "Endorsed by the Florida State Fraternal Order of Police.",
    eyebrow: "New endorsement"
  },
  {
    image: pbaEndorsement,
    title: "Officially endorsed by the Florida Police Benevolent Association.",
    eyebrow: "New endorsement"
  },
  {
    image: firefightersEndorsement,
    title: "Endorsed by Florida Professional Firefighters.",
    eyebrow: "New endorsement"
  },
  {
    image: scottEllisEndorsement,
    title: "Endorsed by former Brevard County Clerk of Courts Scott Ellis.",
    eyebrow: "New endorsement"
  },
  {
    image: sadoffEndorsement,
    title: "Endorsed by Brevard Clerk of Courts & Comptroller Rachel Sadoff.",
    eyebrow: "New endorsement"
  },
  {
    image: rockledgeEndorsement,
    title: "Endorsed by Rockledge Mayor Tom Price.",
    eyebrow: "New endorsement"
  },
  {
    image: brianHodgersScheinerEndorsement,
    title: "Endorsed by William Scheiner, State Attorney for the 18th Judicial Circuit.",
    eyebrow: "New endorsement"
  },
  {
    image: daveWeldonEndorsement,
    title: "Endorsed by former U.S. Congressman Dr. Dave Weldon.",
    eyebrow: "New endorsement"
  },
  { image: floridaRealtorsEndorsement, title: "Florida Realtors" },
  { image: spaceCoastRealtorsEndorsement, title: "Space Coast Association of Realtors" },
  {
    image: spaceCoastYoungRepublicansEndorsement,
    title: "Endorsed by Space Coast Young Republicans.",
    eyebrow: "New endorsement"
  },
  { image: aifEndorsement, title: "Associated Industries of Florida" },
  { image: chamberEndorsement, title: "Florida Chamber of Commerce" },
  { image: conservativeWatchEndorsement, title: "Conservative Watch USA" },
  { image: businessVoiceEndorsement, title: "Business Voice of Florida's Space Coast" }
];

const EndorsementsPage = () => {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2600,
    arrows: false
  };

  return (
    <div className="page-shell internal-page">
      <section className="page-hero">
        <p className="section-kicker">Endorsements</p>
        <h1>Conservative support from across Florida and the Space Coast.</h1>
        <p>
          Brian's campaign has earned backing from business, grassroots, and civic organizations that
          want practical leadership and dependable conservative results.
        </p>
      </section>

      <section className="content-panel media-panel">
        <Slider {...carouselSettings}>
          {carouselSlides.map((slide) => (
            <div key={slide.title} className="campaign-slide">
              {slide.image ? (
                <>
                  <img src={slide.image} alt={slide.title} className="campaign-slide-image" />
                  <div className="campaign-slide-overlay">
                    <p>{slide.title}</p>
                  </div>
                </>
              ) : (
                <div className="campaign-slide-placeholder">
                  <span className="campaign-slide-eyebrow">{slide.eyebrow}</span>
                  <p>{slide.title}</p>
                </div>
              )}
            </div>
          ))}
        </Slider>
      </section>

      <section className="content-panel endorsement-gallery-panel">
        <div className="panel-heading">
          <p className="section-kicker">Endorsements</p>
          <h2>Organizations and leaders backing Brian Hodgers.</h2>
        </div>
        <div className="endorsement-gallery endorsement-gallery-page">
          {endorsementCards.map((endorsement) => (
            <article
              key={endorsement.name}
              className={`endorsement-card ${endorsement.featured ? "endorsement-card-featured" : ""}`}
            >
              {endorsement.image ? (
                <img src={endorsement.image} alt={endorsement.name} className="endorsement-card-image" />
              ) : (
                <div className="endorsement-card-placeholder">
                  <span className="endorsement-card-label">New endorsement</span>
                  <h3>{endorsement.name}</h3>
                  <p>{endorsement.description}</p>
                </div>
              )}
              <div className="endorsement-card-body">
                <h3>{endorsement.name}</h3>
                <p>{endorsement.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default EndorsementsPage;
